import invariant from 'invariant';
import PropTypes from 'prop-types';
import always from "ramda/es/always";
import compose from "ramda/es/compose";
import head from "ramda/es/head";
import when from "ramda/es/when";
import isArray from "ramda-extension/es/isArray";
import React from 'react';
import { useDefaultComponentValue } from '../../../utils/useDefaultComponentValue';
const COMPONENT_NAME = 'FieldLoader';
const loadingProps = {
    className: 'Preloader',
    disabled: true
};
const resolveLoader = (isLoading)=>compose(when(always(isLoading), (child)=>/*#__PURE__*/ React.cloneElement(child, loadingProps)), when(isArray, head), React.Children.toArray);
const FieldLoader = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { children, isLoading = false, ...other } = props;
    invariant(React.Children.count(children) === 1, 'There should be only one child.');
    return /*#__PURE__*/ React.createElement("div", other, resolveLoader(isLoading)(children));
};
FieldLoader.propTypes = {
    /**
	 * Any node that should be wrapped by covered by Preloader when loading app.
	 */ children: PropTypes.node,
    /**
	 * If true any child component will have _Preloader_ className.
	 */ isLoading: PropTypes.bool
};
export default FieldLoader;
